import Messages from "../../components/Messages/Messages";
import MessagesFrontispiece from "../../components/MessagesFrontispiece/MessagesFrontispiece";

interface Props {}

export default function MessagesPage(props: Props) {
  return (
    <div className="App-header anzu_font">
      <MessagesFrontispiece></MessagesFrontispiece>
      <Messages></Messages>
    </div>
  );
}
